<template>
  <!-- 表情包 -->
  <a-popover trigger="click">
    <template #content>
      <div style="width: 260px; height: 160px">
        <img
          v-for="(v, i) in emojiList"
          :key="i"
          :src="`https://oss-resource668.yzdli.com/website/image/faces/${v}`"
          class="img-style"
          @click="selectEmoji(i)"
        />
      </div>
    </template>
    <a-icon type="smile" class="imgBtn" />
  </a-popover>
</template>
<script>
import emoji from '@/const/emoji.js'

export default {
  name: 'ChatNameEmoji',
  props: {
    inpMessage: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      emojiList: emoji.obj,
    }
  },
  methods: {
    selectEmoji(e) {
      const value = (this.inpMessage || '') + e
      this.$data.showModal = false
      this.$emit('selectEmoji', value)
    },
  },
}
</script>
<style lang="scss" scoped>
.imgBtn {
  color: #bbbbbb;
  font-size: 20px;
  margin-right: 15px;
  cursor: pointer;
}
</style>
